import { Module } from 'vuex'
import {
  VendorState,
  Vendor,
  VendorApplication,
  VendorStatus,
  Commission,
  VendorRating,
  Product,
  ProductApprovalStatus,
  Wallet
} from '@/types'

const MOCK_VENDORS: Vendor[] = [
  {
    id: 'v1',
    userId: 'u2',
    businessName: 'BuildRight Supplies',
    businessType: 'company',
    registrationNumber: 'RCA-2023-001',
    taxId: 'TIN-001',
    contactName: 'Alice Uwase',
    email: 'alice@buildright.rw',
    phone: '+250 788 111 222',
    street: 'KG 11 Ave',
    city: 'Kigali',
    region: 'Kigali',
    payoutMethod: 'mobile_money',
    payoutNumber: '+250 788 111 222',
    description: 'Wholesale supplier of cement, steel and roofing materials.',
    status: 'approved',
    commissionRate: 10,
    totalSales: 3,
    totalEarnings: 135000,
    rating: 4.5,
    ratingCount: 12,
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-02-05T00:00:00Z'
  },
  {
    id: 'v2',
    userId: 'u3',
    businessName: 'TileWorld Rwanda',
    businessType: 'individual',
    contactName: 'Bob Ntwari',
    email: 'bob@tileworld.rw',
    phone: '+250 722 333 444',
    street: 'KN 3 Rd',
    city: 'Kigali',
    region: 'Kigali',
    payoutMethod: 'mobile_money',
    payoutNumber: '+250 722 333 444',
    description: 'Specialist in premium floor and wall tiles.',
    status: 'pending',
    commissionRate: 10,
    totalSales: 0,
    totalEarnings: 0,
    rating: 0,
    ratingCount: 0,
    createdAt: '2024-03-10T00:00:00Z',
    updatedAt: '2024-03-10T00:00:00Z'
  },
  {
    id: 'v3',
    userId: 'u4',
    businessName: 'ElectroPro Ltd',
    businessType: 'company',
    registrationNumber: 'RCA-2023-099',
    contactName: 'Carol Ingabire',
    email: 'carol@electropro.rw',
    phone: '+250 733 555 666',
    street: 'KK 15 Ave',
    city: 'Kigali',
    region: 'Eastern',
    payoutMethod: 'bank',
    payoutNumber: 'ACC-123456789',
    description: 'Electrical components and wiring solutions.',
    status: 'rejected',
    commissionRate: 10,
    totalSales: 0,
    totalEarnings: 0,
    rating: 0,
    ratingCount: 0,
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-16T00:00:00Z'
  }
]

const MOCK_COMMISSIONS: Commission[] = [
  {
    id: 'com1',
    orderId: 'ORD-001',
    vendorId: 'v1',
    amount: 60750,
    commissionAmount: 6750,
    rate: 10,
    status: 'paid',
    createdAt: '2024-01-12T00:00:00Z'
  },
  {
    id: 'com2',
    orderId: 'ORD-002',
    vendorId: 'v1',
    amount: 40500,
    commissionAmount: 4500,
    rate: 10,
    status: 'pending',
    createdAt: '2024-02-20T00:00:00Z'
  }
]

const MOCK_RATINGS: VendorRating[] = [
  {
    id: 'r1',
    vendorId: 'v1',
    customerId: 'u1',
    customerName: 'Demo User',
    orderId: 'ORD-001',
    rating: 5,
    comment: 'Fast delivery and great quality cement!',
    createdAt: '2024-01-14T00:00:00Z'
  },
  {
    id: 'r2',
    vendorId: 'v1',
    customerId: 'u5',
    customerName: 'Jean Paul',
    orderId: 'ORD-003',
    rating: 4,
    comment: 'Good materials, packaging could be better.',
    createdAt: '2024-02-10T00:00:00Z'
  }
]

// ─── Mock all vendor products (admin view) ───────────────────────────────────────────
const MOCK_ALL_VENDOR_PRODUCTS: Product[] = [
  {
    id: 'vp1',
    name: 'Premium Portland Cement 50kg',
    slug: 'premium-portland-cement',
    description: 'High-grade Portland cement from BuildRight.',
    price: 19000,
    category: { id: '1', name: 'Cement & Concrete', slug: 'cement-concrete' },
    images: [{ id: '1', url: 'https://placehold.co/400x300/1a3566/ffffff?text=Cement', alt: 'Cement' }],
    stock: 300,
    unit: 'bag',
    sku: 'BR-CEM-001',
    featured: false,
    createdAt: '2024-02-15T00:00:00Z',
    vendorId: 'v1',
    vendorName: 'BuildRight Supplies',
    approvalStatus: 'approved'
  },
  {
    id: 'vp2',
    name: 'Y16 Rebar 12m',
    slug: 'y16-rebar-12m',
    description: 'Grade 60 deformed rebar, 16mm, 12 metres.',
    price: 72000,
    category: { id: '2', name: 'Steel & Iron', slug: 'steel-iron' },
    images: [{ id: '2', url: 'https://placehold.co/400x300/1a3566/ffffff?text=Rebar', alt: 'Rebar' }],
    stock: 120,
    unit: 'piece',
    sku: 'BR-STL-002',
    featured: false,
    createdAt: '2024-02-20T00:00:00Z',
    vendorId: 'v1',
    vendorName: 'BuildRight Supplies',
    approvalStatus: 'pending_approval'
  },
  {
    id: 'vp3',
    name: 'Ceramic Floor Tile 60x60cm',
    slug: 'ceramic-floor-tile-tw',
    description: 'Premium glazed ceramic floor tile.',
    price: 3500,
    category: { id: '4', name: 'Tiles & Flooring', slug: 'tiles-flooring' },
    images: [{ id: '3', url: 'https://placehold.co/400x300/1a3566/ffffff?text=Tile', alt: 'Tile' }],
    stock: 0,
    unit: 'piece',
    sku: 'TW-TIL-001',
    featured: false,
    createdAt: '2024-03-12T00:00:00Z',
    vendorId: 'v2',
    vendorName: 'TileWorld Rwanda',
    approvalStatus: 'pending_approval'
  },
  {
    id: 'vp4',
    name: 'MCB Circuit Breaker 32A',
    slug: 'mcb-32a-ep',
    description: 'Single pole MCB, 32A, DIN rail.',
    price: 4800,
    category: { id: '6', name: 'Electrical', slug: 'electrical' },
    images: [{ id: '4', url: 'https://placehold.co/400x300/1a3566/ffffff?text=MCB', alt: 'MCB' }],
    stock: 85,
    unit: 'piece',
    sku: 'EP-ELC-001',
    featured: false,
    createdAt: '2024-03-16T00:00:00Z',
    vendorId: 'v3',
    vendorName: 'ElectroPro Ltd',
    approvalStatus: 'rejected'
  }
]

// ─── Mock wallets ───────────────────────────────────────────────────────────────────────
const MOCK_WALLETS: Wallet[] = [
  {
    id: 'w1',
    vendorId: 'v1',
    vendorName: 'BuildRight Supplies',
    balance: 101250,
    pendingBalance: 40500,
    totalEarned: 141750,
    totalPaidOut: 40500,
    updatedAt: '2024-02-20T00:00:00Z',
    transactions: [
      { id: 'tx1', vendorId: 'v1', orderId: 'ORD-001', type: 'credit', amount: 60750, description: 'Order ORD-001 earnings (after 10% commission)', status: 'completed', createdAt: '2024-01-12T00:00:00Z' },
      { id: 'tx2', vendorId: 'v1', orderId: undefined, type: 'payout', amount: 40500, description: 'Payout to MTN MoMo +250 788 111 222', status: 'completed', createdAt: '2024-01-20T00:00:00Z' },
      { id: 'tx3', vendorId: 'v1', orderId: 'ORD-002', type: 'credit', amount: 40500, description: 'Order ORD-002 earnings (after 10% commission)', status: 'pending', createdAt: '2024-02-20T00:00:00Z' }
    ]
  },
  {
    id: 'w2',
    vendorId: 'v2',
    vendorName: 'TileWorld Rwanda',
    balance: 0,
    pendingBalance: 0,
    totalEarned: 0,
    totalPaidOut: 0,
    updatedAt: '2024-03-10T00:00:00Z',
    transactions: []
  },
  {
    id: 'w3',
    vendorId: 'v3',
    vendorName: 'ElectroPro Ltd',
    balance: 0,
    pendingBalance: 0,
    totalEarned: 0,
    totalPaidOut: 0,
    updatedAt: '2024-03-15T00:00:00Z',
    transactions: []
  }
]

const vendor: Module<VendorState, unknown> = {
  namespaced: true,

  state: (): VendorState => ({
    profile: null,
    applications: [],
    products: [],
    orders: [],
    commissions: [],
    ratings: [],
    wallet: null,
    allWallets: [],
    allVendorProducts: [],
    loading: false,
    error: null
  }),

  getters: {
    isApproved: (state) => state.profile?.status === 'approved',
    isPending: (state) => state.profile?.status === 'pending',
    pendingApplications: (state) => state.applications.filter(v => v.status === 'pending'),
    pendingProducts: (state) => state.products.filter(p => p.approvalStatus === 'pending_approval'),
    totalEarnings: (state) => state.commissions.reduce((s, c) => s + c.amount, 0),
    pendingEarnings: (state) => state.commissions.filter(c => c.status === 'pending').reduce((s, c) => s + c.amount, 0)
  },

  mutations: {
    SET_LOADING (state, loading: boolean) { state.loading = loading },
    SET_ERROR (state, error: string | null) { state.error = error },
    SET_PROFILE (state, profile: Vendor | null) { state.profile = profile },
    SET_APPLICATIONS (state, vendors: Vendor[]) { state.applications = vendors },
    SET_VENDOR_PRODUCTS (state, products: Product[]) { state.products = products },
    SET_VENDOR_ORDERS (state, orders) { state.orders = orders },
    SET_COMMISSIONS (state, commissions: Commission[]) { state.commissions = commissions },
    SET_RATINGS (state, ratings: VendorRating[]) { state.ratings = ratings },
    ADD_VENDOR (state, vendor: Vendor) { state.applications.unshift(vendor) },
    UPDATE_VENDOR_STATUS (state, { id, status }: { id: string; status: VendorStatus }) {
      const v = state.applications.find(a => a.id === id)
      if (v) { v.status = status; v.updatedAt = new Date().toISOString() }
      if (state.profile?.id === id) { state.profile.status = status }
    },
    ADD_VENDOR_PRODUCT (state, product: Product) { state.products.unshift(product) },
    UPDATE_PRODUCT_APPROVAL (state, { id, status }: { id: string; status: ProductApprovalStatus }) {
      const p = state.products.find(p => p.id === id)
      if (p) p.approvalStatus = status
    },
    UPDATE_VENDOR_PRODUCT (state, updated: Product) {
      const idx = state.products.findIndex(p => p.id === updated.id)
      if (idx !== -1) state.products.splice(idx, 1, updated)
    },
    DELETE_VENDOR_PRODUCT (state, id: string) {
      state.products = state.products.filter(p => p.id !== id)
    },
    ADD_RATING (state, rating: VendorRating) { state.ratings.push(rating) },
    SET_WALLET (state, wallet: Wallet | null) { state.wallet = wallet },
    SET_ALL_WALLETS (state, wallets: Wallet[]) { state.allWallets = wallets },
    SET_ALL_VENDOR_PRODUCTS (state, products: Product[]) { state.allVendorProducts = products }
  },

  actions: {
    // ── Vendor registration ──────────────────────────────────────────────────
    async applyAsVendor ({ commit }, application: VendorApplication) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 800))
        const newVendor: Vendor = {
          id: 'v' + Date.now(),
          userId: 'current_user',
          ...application,
          status: 'pending',
          commissionRate: 10,
          totalSales: 0,
          totalEarnings: 0,
          rating: 0,
          ratingCount: 0,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
        commit('ADD_VENDOR', newVendor)
        commit('SET_PROFILE', newVendor)
        return newVendor
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Admin: fetch all vendors ─────────────────────────────────────────────
    async fetchAllVendors ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        commit('SET_APPLICATIONS', [...MOCK_VENDORS])
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Admin: approve / reject vendor ──────────────────────────────────────
    async updateVendorStatus ({ commit }, payload: { id: string; status: VendorStatus }) {
      await new Promise(resolve => setTimeout(resolve, 400))
      commit('UPDATE_VENDOR_STATUS', payload)
    },

    // ── Vendor: fetch own profile ────────────────────────────────────────────
    async fetchVendorProfile ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        // Simulate: current user is vendor v1
        commit('SET_PROFILE', MOCK_VENDORS[0])
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Vendor: fetch own products ───────────────────────────────────────────
    async fetchVendorProducts ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        const vendorProducts: Product[] = [
          {
            id: 'vp1',
            name: 'Premium Portland Cement 50kg',
            slug: 'premium-portland-cement',
            description: 'High-grade Portland cement from BuildRight.',
            price: 19000,
            category: { id: '1', name: 'Cement & Concrete', slug: 'cement-concrete' },
            images: [{ id: '1', url: 'https://placehold.co/400x300/1a3566/ffffff?text=Cement', alt: 'Cement' }],
            stock: 300,
            unit: 'bag',
            sku: 'BR-CEM-001',
            featured: false,
            createdAt: '2024-02-15T00:00:00Z',
            vendorId: 'v1',
            vendorName: 'BuildRight Supplies',
            approvalStatus: 'approved'
          },
          {
            id: 'vp2',
            name: 'Y16 Rebar 12m',
            slug: 'y16-rebar-12m',
            description: 'Grade 60 deformed rebar, 16mm, 12 metres.',
            price: 72000,
            category: { id: '2', name: 'Steel & Iron', slug: 'steel-iron' },
            images: [{ id: '2', url: 'https://placehold.co/400x300/1a3566/ffffff?text=Rebar', alt: 'Rebar' }],
            stock: 120,
            unit: 'piece',
            sku: 'BR-STL-002',
            featured: false,
            createdAt: '2024-02-20T00:00:00Z',
            vendorId: 'v1',
            vendorName: 'BuildRight Supplies',
            approvalStatus: 'pending_approval'
          }
        ]
        commit('SET_VENDOR_PRODUCTS', vendorProducts)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Vendor: create product ───────────────────────────────────────────────
    async createVendorProduct ({ commit, state }, product: Omit<Product, 'id' | 'createdAt'>) {
      const newProduct: Product = {
        ...product,
        id: 'vp' + Date.now(),
        createdAt: new Date().toISOString(),
        vendorId: state.profile?.id,
        vendorName: state.profile?.businessName,
        approvalStatus: 'pending_approval'
      }
      commit('ADD_VENDOR_PRODUCT', newProduct)
      return newProduct
    },

    async updateVendorProduct ({ commit }, product: Product) {
      commit('UPDATE_VENDOR_PRODUCT', { ...product, approvalStatus: 'pending_approval' })
    },

    async deleteVendorProduct ({ commit }, id: string) {
      commit('DELETE_VENDOR_PRODUCT', id)
    },

    // ── Admin: approve / reject product ─────────────────────────────────────
    async approveProduct ({ commit }, id: string) {
      await new Promise(resolve => setTimeout(resolve, 300))
      commit('UPDATE_PRODUCT_APPROVAL', { id, status: 'approved' })
    },

    async rejectProduct ({ commit }, id: string) {
      await new Promise(resolve => setTimeout(resolve, 300))
      commit('UPDATE_PRODUCT_APPROVAL', { id, status: 'rejected' })
    },

    // ── Vendor: fetch own orders ─────────────────────────────────────────────
    async fetchVendorOrders ({ commit, state }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        const vendorId = state.profile?.id
        // Use mock orders filtered by vendorId on the order items
        const MOCK_VENDOR_ORDERS = [
          {
            id: 'ORD-001',
            customer: { id: '1', name: 'Demo User', email: 'demo@jengahills.com', role: 'customer' as const, createdAt: '2024-01-10T00:00:00Z' },
            items: [
              {
                product: {
                  id: 'vp1',
                  name: 'Premium Portland Cement 50kg',
                  slug: 'premium-portland-cement',
                  description: '',
                  price: 19000,
                  category: { id: '1', name: 'Cement & Concrete', slug: 'cement-concrete' },
                  images: [{ id: '1', url: 'https://placehold.co/400x300/1a3566/ffffff?text=Cement', alt: 'Cement' }],
                  stock: 300,
                  unit: 'bag',
                  sku: 'BR-CEM-001',
                  featured: false,
                  createdAt: '2024-02-15T00:00:00Z',
                  vendorId: 'v1',
                  vendorName: 'BuildRight Supplies',
                  approvalStatus: 'approved' as const
                },
                quantity: 3,
                unitPrice: 19000,
                vendorId: 'v1'
              }
            ],
            status: 'delivered' as const,
            paymentMethod: 'mobile_money' as const,
            paymentStatus: 'paid' as const,
            shippingAddress: { fullName: 'Demo User', phone: '+250700000000', street: 'KN 5 Rd', city: 'Kigali', region: 'Kigali' },
            subtotal: 57000,
            shippingFee: 5000,
            total: 62000,
            createdAt: '2024-01-10T09:00:00Z',
            updatedAt: '2024-01-12T14:00:00Z'
          }
        ]
        const vendorOrders = vendorId
          ? MOCK_VENDOR_ORDERS.filter(o => o.items.some(i => i.vendorId === vendorId))
          : []
        commit('SET_VENDOR_ORDERS', vendorOrders)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Vendor: fetch commissions ────────────────────────────────────────────
    async fetchCommissions ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        commit('SET_COMMISSIONS', MOCK_COMMISSIONS)
        commit('SET_RATINGS', MOCK_RATINGS)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Vendor: fetch own wallet ────────────────────────────────────────────
    async fetchVendorWallet ({ commit, state }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        const vendorId = state.profile?.id
        const wallet = MOCK_WALLETS.find(w => w.vendorId === vendorId) ?? null
        commit('SET_WALLET', wallet)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Admin: fetch all wallets ────────────────────────────────────────────
    async fetchAllWallets ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        commit('SET_ALL_WALLETS', MOCK_WALLETS)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // ── Admin: fetch all vendor products ─────────────────────────────────────
    async fetchAllVendorProducts ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 400))
        commit('SET_ALL_VENDOR_PRODUCTS', MOCK_ALL_VENDOR_PRODUCTS)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}

export default vendor
